import { render, staticRenderFns } from "./SentenceParsingForm.vue?vue&type=template&id=8e27f6f6&scoped=true&lang=pug&"
import script from "./SentenceParsingForm.vue?vue&type=script&lang=js&"
export * from "./SentenceParsingForm.vue?vue&type=script&lang=js&"
import style0 from "./SentenceParsingForm.vue?vue&type=style&index=0&id=8e27f6f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e27f6f6",
  null
  
)

export default component.exports